import type { CreditConsultation } from '@/shared/api/resources';
import { formatDateTime } from '@/shared/lib/format';
import { Button } from '@/shared/ui/Button';
import { Modal } from '@/shared/ui/Modal';

import { Info, InfoGrid } from './shared';
import { textoDoValorDaConsulta, tipoDaConsulta } from './valorDaConsulta';

/**
 * Os dados de uma consulta do Historico de Consultas: tudo o que a leitura trouxe, um
 * valor por elemento, com a falta dita como falta. Somente leitura.
 */
export function DadosDaConsultaModal({
  consulta,
  onClose,
}: {
  consulta: CreditConsultation | null;
  onClose: () => void;
}) {
  if (!consulta) return null;
  return (
    <Modal
      open
      onClose={onClose}
      title={`Consulta ${tipoDaConsulta(consulta)} de ${formatDateTime(consulta.consulted_at)}`}
      description="Os dados como a consulta trouxe. O que o fornecedor nao devolveu aparece como nao encontrado."
      size="lg"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      }
    >
      <InfoGrid>
        {(consulta.values ?? []).map((valor) => (
          <Info
            key={valor.element}
            label={valor.label}
            value={textoDoValorDaConsulta(valor, valor.element === 'cnae_principal')}
          />
        ))}
      </InfoGrid>
    </Modal>
  );
}
